import i18n from 'src/i18n';
//──── constants ─────────────────────────────────────────────────────────────────────────
import {
  RECEPTION_BANK_CONTACT,
  RECEPTION_CARD,
  RECEPTION_CASH,
  RECEPTION_INVOICE,
  RECEPTION_DEBT,
  RECEPTION_WORK_ACCIDENT,
  RECEPTION_HOSPITAL_ADMISSION,
  PRO_DEO,
  IN_APP_PAYMENT
} from 'services/constants';

export const paymentMethodsList = [
  {
    type: RECEPTION_BANK_CONTACT,
    translateLabel: ['value_bancontact'],
    icon: BanContact,
    activeIcon: BanContactActive
  },
  {
    type: RECEPTION_CARD,
    translateLabel: ['value_visa', 'value_mastercard'],
    icon: Card,
    activeIcon: CardActive
  },
  {
    type: RECEPTION_CASH,
    translateLabel: ['value_cash'],
    icon: Cash,
    activeIcon: CashActive
  },
  {
    type: RECEPTION_INVOICE,
    translateLabel: ['value_invoice'],
    icon: Invoice,
    activeIcon: InvoiceActive
  },
  {
    type: RECEPTION_DEBT,
    translateLabel: ['value_ocmw', 'value_debt_mediation'],
    icon: Debt,
    activeIcon: DebtActive
  },
  {
    type: RECEPTION_WORK_ACCIDENT,
    translateLabel: ['value_work_accident'],
    icon: Work,
    activeIcon: WorkActive
  },
  {
    type: PRO_DEO,
    translateLabel: ['prodeo_invoice'],
    icon: ProDeo,
    activeIcon: ProDeo
  },
  {
    type: RECEPTION_HOSPITAL_ADMISSION,
    translateLabel: ['value_hospital_admission'],
    icon: MedicalKit,
    activeIcon: MedicalKitActive
  },
  {
    type: IN_APP_PAYMENT,
    translateLabel: ['inapp_in_invoice'],
    icon: InApp,
    activeIcon: InApp
  }
];

//──── images ────────────────────────────────────────────────────────────────────────────
import BanContact from 'assets/images/invoice/bancontactIcon.svg';
import Card from 'assets/images/invoice/cardIcon.svg';
import Cash from 'assets/images/invoice/cash.svg';
import Invoice from 'assets/images/invoice/invoiceIcon.svg';
import Debt from 'assets/images/invoice/debtIcon.svg';
import Work from 'assets/images/invoice/workIcon.svg';
import BanContactActive from 'assets/images/invoice/bancontactIcon-active.svg';
import CardActive from 'assets/images/invoice/cardIcon-active.svg';
import CashActive from 'assets/images/invoice/cash-active.svg';
import InvoiceActive from 'assets/images/invoice/invoiceIcon-active.svg';
import DebtActive from 'assets/images/invoice/debtIcon-active.svg';
import WorkActive from 'assets/images/invoice/workIcon-active.svg';
import MedicalKit from 'assets/images/invoice/medical-kit.svg';
import MedicalKitActive from 'assets/images/invoice/medical-kit-active.svg';
import ProDeo from 'assets/images/invoice/terminal-active.svg';
import InApp from 'assets/images/invoice/in-app-active.svg';

//──── Methods ───────────────────────────────────────────────────────────────────────────

export const getLocalizeLabel = (paymentListElement, separator) => {
  return paymentListElement &&
    paymentListElement.translateLabel &&
    typeof paymentListElement.translateLabel === 'object' &&
    paymentListElement.translateLabel.length
    ? paymentListElement.translateLabel.map((keyLabel, index, arr) => {
      const _sep = separator ? separator : ' ';
      return `${i18n.t(keyLabel)}${arr.length - 1 === index ? '' : _sep}`;
    })
    : null;
};

export const getPayment = type => {
  return (
    type &&
    paymentMethodsList.find(item => String(item.type).toLowerCase() === String(type).toLowerCase())
  );
};

export const getSum = (arr, target) => {
  let sum = 0;
  if (arr && Array.isArray(arr) && target) {
    for (let i = 0; i < arr.length; i++) {
      if (typeof arr[i][target] === 'number') {
        sum += arr[i][target];
      }
    }
  }
  return sum;
};
